import SignIn from './src/home.vue'

let views = {
    SignIn
};

export default views;